export default "__VITE_ASSET__c6902274__"